import { Link } from "react-router";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useCallback, useEffect, useRef, useState } from "react";
import logo from "../assets/img/logo.png";

export const NavigationBar = () => {
  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);
  const closeMenu = () => setExpanded(false);

  const handleClickOutside = useCallback((e) => {
    if (navRef.current && !navRef.current.contains(e.target)) {
      setExpanded(false);
    }
  }, []);

  useEffect(() => {
    if (!expanded) return;
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [expanded, handleClickOutside]);

  return (
    <Navbar
        ref={navRef}
        expand="md"
        variant="light"
        expanded={expanded}
        onToggle={(val) => setExpanded(val)}
        className="main-navbar"
      >
        <Container fluid className="navbar-inner">
          {/* TOP LEFT: Logo */}
          <Navbar.Brand as={Link} to="/" className="navbar-logo" onClick={closeMenu}>
            <img src={logo} alt="Logo" />
          </Navbar.Brand>

          {/* TOP RIGHT: Hamburger (only visible on mobile) */}
          <Navbar.Toggle aria-controls="navbar-content" className="navbar-toggle">
            <svg className="navbar-hamburger" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
              <line className="navbar-hamburger-line top" x1="3" y1="6" x2="21" y2="6" />
              <line className="navbar-hamburger-line mid" x1="3" y1="12" x2="21" y2="12" />
              <line className="navbar-hamburger-line bot" x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </Navbar.Toggle>

          {/* COLLAPSIBLE MENU: everything else */}
          <Navbar.Collapse id="navbar-content" className="navbar-collapse-custom">
            <Nav className="navbar-links">
              <Nav.Link as={Link} to="/menu" onClick={closeMenu}>Menu</Nav.Link>
              <Nav.Link as={Link} to="/catering" onClick={closeMenu}>Catering</Nav.Link>
              <Nav.Link as={Link} to="/schedule" onClick={closeMenu}>Weekly Schedule</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={closeMenu} className="navbar-push-right">About</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={closeMenu}>Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
  );
};
